export const nav = {
  get: {
    name: "我收到的通知",
    status: "get",
    routerName: 'GetNotice'
  },
  send: {
    name: "我发送的通知",
    status: "send",
    routerName: 'SendNotice'
  },
  all: {
    name: "全部通知",
    status: "other",
    routerName: 'OtherNotice'
  }
}

export const usersList = [
  {key: '十一人制机构管理员', value: 'organ'},
  {key: '十一人制讲师', value: 'teacher'},
  {key: '十一人制学员', value: 'student'},
  {key: '十一人制学员(所有学员)', value: 'studentALL'},
]

export const usersListFive = [
  {key: '五人制机构管理员', value: 'orgFive'},
  {key: '五人制讲师', value: 'teaFive'},
  {key: '五人制学员', value: 'stuFive'},
  {key: '五人制学员(所有学员)', value: 'stuALL'},
]
